import React, { ReactNode } from "react";
import { useStrings } from "../common-strings";
import Popup from "./Popup";
import './dlgs.css';

export default function OkDlg({ title, msg, close, onClose }: OKDlgProps) {
    const commonStrings = useStrings();
    const closeLabel = close ?? commonStrings.ok;

    return <Popup onClose={onClose}>
        <div className='dlg-popup'>
            <div className='orders'>
                <div className='dlg-title'>{title}</div>
                <div className='dlg-msg'>{msg}</div>
            </div>
            <div className='ok-btn' onClick={onClose}>
                {closeLabel}
            </div>
        </div>
    </Popup>
}

type OKDlgProps = {
    title: ReactNode;
    msg: ReactNode;
    close?: ReactNode;
    onClose: () => void
}